import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import cs from 'classnames'
import {Table, Thead, Th, Tr, Td, collapseTdWithClass, b} from 'components/reactable'
import styles from './agenda.scss'
import {fetchAgendaData, fetchUserData, fetchSubscribersList} from 'state/actions'
import {formatDate} from 'lib/helpers'
import {sortBy} from 'lodash/collection'
import Subscribe from './subscribe'
import {ContactNameValue} from '../office/contacts'
import ComponentPageDom from 'elements/ComponentPageDom'
import HtmlContent from 'elements/HtmlContent'
import i18n from 'lib/i18n'
import underscore from 'underscore'

const _ = i18n('agenda')

const AvailablePlaces = ({capacity, available}) => (
	<span>
		{`${available}/${capacity}`}
	</span>
)
AvailablePlaces.propTypes = {
	capacity: PropTypes.number,
	available: PropTypes.number,
}

const DateValue = ({date}) => <span>{formatDate(date)}</span>
DateValue.propTypes = {date: PropTypes.any}

const DateRangeValue = ({startDate, endDate, startTime, endTime}) => {
	const start = formatDate(startDate)
	const end = formatDate(endDate)
	const same = (start === end)
	const startString = `${start} ${startTime}`
	const endString = `${same ? '' : `${end} `}${endTime}`

	return (<span>{startString} - {endString}</span>)
}
DateRangeValue.propTypes = {
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	startTime: PropTypes.string,
	endTime: PropTypes.string,
}

const LocationValue = ({location: {street = '?', houseNum = '', houseNumExt, zip = '?', city = '?', country = ''}}) => (
	<div className={styles.address}>
		{street} {houseNum}{houseNumExt ? `/${houseNumExt}` : ''} – {zip} {city} {country}
	</div>
)
LocationValue.propTypes = {location: PropTypes.object}

const EventContactsDom = ({contacts, date}) => (
	<div className={styles.subscribers}>
		{contacts && date.subscriberIds.map((cId, key) =>
			<ContactNameValue key={key} contact={contacts.find(u => u._id === cId)}/>
		)}
	</div>
)
EventContactsDom.propTypes = {
	date: PropTypes.object,
	contacts: PropTypes.array,
}

const Button = ({event, label}) => (
	<div>
		<input
			onClick={event}
			type="button"
			className={styles.greyButton}
			value={label}
		/>
	</div>
)
Button.propTypes = {
	label: PropTypes.string,
	event: PropTypes.func,
}

const EventPeriod = ({
	date: {
		_id, startDate, endDate, startTime, endTime, capacity, available, subscribeOpen, startSubscribe, endSubscribe,
	},
	date, contacts, openPopup, subscribersList, userId,
}) => (
	<tr className={styles.eventContainer}>
		<td className={styles.dateRange}>
			<DateRangeValue
				startDate={startDate}
				endDate={endDate}
				startTime={startTime}
				endTime={endTime}
			/>
		</td>
		<td className={styles.places}>
			<AvailablePlaces capacity={capacity} available={available}/>
		</td>
		<td className={styles.subsCont}>
			<div className={styles.subs}>
				<EventContactsDom {...{contacts, date}}/>
				{openPopup && (
					subscribeOpen ? (
						<div className={styles.subscribeButtonContainer}>
							<Button event={() => openPopup(date)} label={_("subscribeButton")}/>
							<small>{_('subscribeEnds')} <DateValue date={endSubscribe}/></small>
						</div>
					) : (
						new Date(startSubscribe) < new Date() ? (
							<em>{_('subscribeEnded')}</em>
						) : (
							<em>
								{_('subscribeStartsOn')} <DateValue date={startSubscribe}/>
							</em>
						)
					)
				)}
			</div>
		</td>
	</tr>
)
EventPeriod.propTypes = {
	date: PropTypes.shape({
		_id: PropTypes.string.isRequired,
		startDate: PropTypes.string.isRequired,
		endDate: PropTypes.string.isRequired,
		startTime: PropTypes.string.isRequired,
		endTime: PropTypes.string.isRequired,
		capacity: PropTypes.number.isRequired,
		available: PropTypes.number.isRequired,
		subscribeOpen: PropTypes.bool.isRequired,
		startSubscribe: PropTypes.string,
		endSubscribe: PropTypes.string,
	}),
	contacts: PropTypes.array,
	openPopup: PropTypes.func,
	subscribersList: PropTypes.func,
	userId: PropTypes.string.isRequired,
}

const EventDatesDom = ({dates, contacts, openPopup, userId, subscribersList}) => (
	<table className={styles.eventMainContainer}>
		<tbody>
			<tr className={styles.headerContainer}>
				<th className={styles.dateHeader}>
					{_('date')}
				</th>
				<th className={styles.attendeesHeader}>
					{_('freeSeatsNum')}
				</th>
				<th className={styles.subscribeHeader}>
					{_('subscribe')}
				</th>
			</tr>
			{dates.map((date, key) =>
				<EventPeriod
					key={key}
					{...{
						date,
						contacts,
						openPopup,
						subscribersList,
						userId,
					}}
				/>
			)}
		</tbody>
	</table>
)

EventDatesDom.propTypes = {
	dates: PropTypes.arrayOf(PropTypes.object),
	contacts: PropTypes.arrayOf(PropTypes.object),
	openPopup: PropTypes.func,
	subscribersList: PropTypes.func,
	userId: PropTypes.string.isRequired,
}

const EventDescriptionDom = ({event}) => (
	<div className={styles.description}>
		<div className={styles.icon}>
			<img src={require('resources/images/a-info_2x.png')}/>
			{_('eventTitle')}
		</div>
		{event.desc &&
			<HtmlContent className={styles.descriptionContent} content={event.desc[global.lang]}/>
		}
		{event.location && (
			<div>
				<div className={styles.icon}>
					<img src={require('resources/images/a-location_2x.png')}/>
					{_('location')}
				</div>
				<LocationValue location={event.location}/>
			</div>
		)}
	</div>
)
EventDescriptionDom.propTypes = {
	isPhone: PropTypes.bool.isRequired,
	isTablet: PropTypes.bool.isRequired,
	event: PropTypes.object,
}

const apiKey = "AIzaSyBXJ3lsUMlS2I4tCr3ppQ_ZgijeI7d_n-s"

const GmapEmbed = ({isPhone, isTablet, googlePlaceId, lat, lng, q}) => {
	let search
	if (googlePlaceId) {
		search = `place_id:${googlePlaceId}`
	} else if (lat && lng) {
		search = `${lat},${lng}`
	} else {
		search = q
	}
	if (!search) {
		return <div/>
	}
	search = encodeURIComponent(search)

	return (
		<div className={styles.gmapEmbedWrapper}>
			{isPhone || isTablet ? (lat && lng &&
				<a href={`https://www.google.com/maps/place?q=${search}&zoom=17`}>
					<img src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&key=${apiKey}&markers=size:large%7Ccolor:0xff0000%7Clabel:%7C${lat},+${lng}`}/>
				</a>
			) : (
				<iframe
					className={styles.map}
					src={`https://www.google.com/maps/embed/v1/place?q=${search}&zoom=17&key=${apiKey}`}
					width="100%"
					height="400px"
				/>
			)}
		</div>
	)
}
GmapEmbed.propTypes = {
	isPhone: PropTypes.bool.isRequired,
	isTablet: PropTypes.bool.isRequired,
	googlePlaceId: PropTypes.string,
	lat: PropTypes.number,
	lng: PropTypes.number,
	q: PropTypes.string,
}

const Event = ({event, contacts, openPopup, subscribersList, userId, isPhone, isTablet}) => (
	<div className={cs(styles.content, styles.noPointer)}>
		<EventDatesDom
			dates={event.dates}
			contacts={contacts}
			openPopup={event.allowSubscribe ? openPopup : undefined}
			subscribersList={subscribersList}
			userId={userId}
		/>
		<EventDescriptionDom event={event} isPhone={isPhone} isTablet={isTablet}/>
		{event.location &&
			<EventMap event={event} isPhone={isPhone} isTablet={isTablet}/>
		}
	</div>
)
Event.propTypes = {
	event: PropTypes.object,
	isPhone: PropTypes.bool.isRequired,
	contacts: PropTypes.arrayOf(PropTypes.object),
	openPopup: PropTypes.func.isRequired,
	subscribersList: PropTypes.func,
	userId: PropTypes.string.isRequired,
}

const EventMap = ({event, isPhone, isTablet}) => {
	const {location: {googlePlaceId, lat, lng}} = event

	return (
		<div className={styles.map}>
			{((lat && lng) || googlePlaceId) &&
				<GmapEmbed
					{...{
						isPhone,
						isTablet,
						googlePlaceId,
						lat, lng,
					}}
				/>
			}
		</div>
)}
EventMap.propTypes = {
	event: PropTypes.object,
	isPhone: PropTypes.bool.isRequired,
	isTablet: PropTypes.bool.isRequired,
}

const AgendaTableDom = ({events, contacts, isOpened, toggleSub, openPopup, subscribersList, userId, isPhone, isTablet}) => (
	<Table
		sortable={[
			{column: 'ticketDate', sortFunction: 'Date'},
		]}
		defaultSort={{
			column: 'ticketDate',
			direction: 'asc',
		}}

		itemsPerPage={10}
		pageButtonLimit={5}
	>
		<Thead>
			<Th column="collapse" label=""/>
			<Th column="checkmark" label=""/>
			<Th column="description">
				<strong>{_("eventTitle")}</strong>
			</Th>
			<Th column="ticketDate">
				<strong>{_("date")}</strong>
			</Th>
		</Thead>
		{events && events.map((event) => (
			<Tr
				key={event._id}
				className={styles.row}
				onClick={() => toggleSub(event._id)}
			>
				{collapseTdWithClass({
					column: 'collapse',
					className: styles.checkmarkColumn,
					isOpened: isOpened[event._id],
					children:
						<Event {...{event, contacts, openPopup, subscribersList, userId, isPhone, isTablet}}/>,
				})}
				<Td column="checkmark" className={styles.checkmarkColumn}>
					{event.highlighted ? <img className={styles.checkmark} src={require('resources/icn-checkmark.svg')}/> : ''}
				</Td>
				<Td column="description" className={styles.descriptionColumn}>{event.title[global.lang]}</Td>
				<Td column="ticketDate" className={styles.dateColumn} value={event.dates[0].startDate}>
					{event.dates.length > 0 ? (
						<DateRangeValue
							startDate={event.dates[0].startDate}
							startTime={event.dates[0].startTime}
							endDate={event.dates[0].endDate}
							endTime={event.dates[0].endTime}
						/>
					) : ''}
				</Td>
			</Tr>
			)
		)}
	</Table>
)
AgendaTableDom.propTypes = {
	events: PropTypes.arrayOf(PropTypes.object),
	contacts: PropTypes.arrayOf(PropTypes.object),
	isOpened: PropTypes.object,
	toggleSub: PropTypes.func.isRequired,
	openPopup: PropTypes.func,
	isPhone: PropTypes.bool.isRequired,
	isTablet: PropTypes.bool.isRequired,
	userId: PropTypes.string.isRequired,
	subscribersList: PropTypes.func,
}

const SubscriberPopupDom = ({children}) => (
	<div className={styles.overlay}>
		{children}
	</div>
)

SubscriberPopupDom.propTypes = {
	children: React.PropTypes.node,
}

@connect(
	state => ({
		events: state.agenda.events,
		contacts: state.agenda.users,
		userId: state.app.userId,
		isPhone: state.responsive.isPhone,
		lang: state.app.lang,
	}),
	{fetchUserData, fetchAgendaData, fetchSubscribersList}
)
export default class Agenda extends Component {
	static propTypes = {
		events: PropTypes.arrayOf(PropTypes.object).isRequired,
		contacts: PropTypes.arrayOf(PropTypes.object),
		isPhone: PropTypes.bool.isRequired,
		userId: PropTypes.string.isRequired,
		lang: PropTypes.string.isRequired,
		fetchAgendaData: PropTypes.func,
		fetchUserData: PropTypes.func,
		fetchSubscribersList: PropTypes.func,
	}
	constructor(props) {
		super(props)
		this.state = {isOpened: {}, subscriberPopup: false}
	}
	componentDidMount() {
		this.update()
	}
	update() {
		this.props.fetchAgendaData()
		this.props.fetchUserData()
	}

	toggle(id) {
		this.setState({isOpened: {...this.state.isOpened, [id]: !this.state.isOpened[id]}})
	}

	openPopup(date) {
		const {capacity, subscriberIds, available} = date
		this.setState({subscriberPopup: true, dateId: date._id, activeSubscribers: subscriberIds, capacity, available})
	}

	closePopup() {
		this.update()
		this.setState({subscriberPopup: false})
	}

	sortByDate(events) {
		return events.map(event => ({...event, dates: sortBy(event.dates, date => date.startDate)}))
	}

	render() {
		const {events, contacts, isPhone, fetchSubscribersList, userId, lang} = this.props
		const langEvents = events.filter(e => e.language === lang)
		const sortedEvents = this.sortByDate(langEvents)
		const {subscriberPopup, dateId, activeSubscribers, isOpened, capacity, available} = this.state
		const contactOptions = contacts && contacts.map(contact => (
			{label: <ContactNameValue contact={contact}/>, value: contact._id}
		))
		return (
			<ComponentPageDom
				title={_('title')}
				subtitle={_('subtitle')}
			>
				<AgendaTableDom
					events={sortedEvents}
					contacts={contacts}
					isOpened={isOpened}
					openPopup={date => this.openPopup(date)}
					subscribersList={fetchSubscribersList}
					toggleSub={id => this.toggle(id)}
					isPhone={isPhone}
					userId={userId}
				/>
				{subscriberPopup &&
					<SubscriberPopupDom>
						<Subscribe
							capacity={capacity}
							dateId={dateId}
							activeSubscribers={activeSubscribers}
							subscriberOptions={contactOptions}
							onClose={() => this.closePopup()}
							placesLeft={available}
						/>
					</SubscriberPopupDom>
				}
			</ComponentPageDom>
		)
	}
}



// WEBPACK FOOTER //
// ./components/agenda/index.jsx